import { CountryAssessments, HIHAssessmentResponseByContinent } from "@app/features/other/genericApiSlice";
import { HIH_FORUM_PATH } from "./constants";

export const getFlagUrl = (isoCode: string) =>
  `https://flagcdn.com/${isoCode.toLowerCase()}.svg`;

export const countryHasAssessments = (country: CountryAssessments) =>
  country.years.some(({ assessments }) => assessments.length > 0);

export const countryHasAssessmentsForYear = (country: CountryAssessments, year: number) =>
  country.years.some(({ year: y, assessments }) => y === year && assessments.length > 0);

/** Distinct years that have at least one assessment, sorted latest first */
export const getAssessmentYears = (continents: HIHAssessmentResponseByContinent[]) =>
  Array.from(
    new Set(
      continents
        .flatMap((continent) => continent.countries)
        .flatMap((country) => country.years)
        .filter(({ assessments }) => assessments.length > 0)
        .map(({ year }) => year)
    )
  ).sort((a, b) => b - a);

/** Continents narrowed to countries with an assessment for the given year; empty continents dropped */
export const filterContinentsByYear = (
  continents: HIHAssessmentResponseByContinent[],
  year: number
): HIHAssessmentResponseByContinent[] =>
  continents
    .map((continent) => ({
      ...continent,
      countries: continent.countries.filter((country) => countryHasAssessmentsForYear(country, year)),
    }))
    .filter((continent) => continent.countries.length > 0);

export const countryForumPath = (isoCode: string) =>
  `${HIH_FORUM_PATH}/${isoCode.toUpperCase()}`;
